import { BaseEntity } from "yt-ng-framework";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

export class FinDokumentStavkaView extends BaseEntity{
    constructor(){
        super();
    }

    KontoSifra: string;
    KontoNaziv: string;
    Komitent: string;
    Brfak: string;
    Datfak: NgbDate;
    Datdpo: NgbDate;
    Veza: number;
    Duguje: number;
    Potrazuje: number;
    DDuguje: number;
    DPotrazuje: number;
    Valuta: string;
    OrgJed: string;

    Deserialize(input:any){
        this.ID=input.ID;
        this.KontoSifra=input.KontoSifra;
        this.KontoNaziv=input.KontoNaziv;
        this.Komitent=input.Komitent;
        this.Brfak=input.Brfak;
        this.Datfak=input.Datfak;
        this.Datdpo=input.datdpo;
        this.Veza=input.Veza;
        this.Duguje=input.Duguje;
        this.Potrazuje=input.Potrazuje;
        this.DDuguje=input.DDuguje;
        this.DPotrazuje=input.DPotrazuje;
        this.Valuta=input.Valuta;
        this.OrgJed=input.OrgJed;
        return this;
    }

    Serialize(input:FinDokumentStavkaView){
        return input;
    }
}